module.exports = __webpack_public_path__ + "static/media/github.8dc1f056.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/github.svg
// module id = 1094
// module chunks = 0